/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedOccupancyStatsResponseGenderDistribution
 */
export interface BedOccupancyStatsResponseGenderDistribution {
    /**
     * Number of male leads
     */
    male_count: number;
    /**
     * Number of female leads
     */
    female_count: number;
    /**
     * Number of leads with other gender
     */
    other_count: number;
}

/**
 * Check if a given object implements the BedOccupancyStatsResponseGenderDistribution interface.
 */
export function instanceOfBedOccupancyStatsResponseGenderDistribution(value: object): value is BedOccupancyStatsResponseGenderDistribution {
    if (!('male_count' in value) || value['male_count'] === undefined) return false;
    if (!('female_count' in value) || value['female_count'] === undefined) return false;
    if (!('other_count' in value) || value['other_count'] === undefined) return false;
    return true;
}

export function BedOccupancyStatsResponseGenderDistributionFromJSON(json: any): BedOccupancyStatsResponseGenderDistribution {
    return BedOccupancyStatsResponseGenderDistributionFromJSONTyped(json, false);
}

export function BedOccupancyStatsResponseGenderDistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedOccupancyStatsResponseGenderDistribution {
    if (json == null) {
        return json;
    }
    return {
        
        'male_count': json['male_count'],
        'female_count': json['female_count'],
        'other_count': json['other_count'],
    };
}

export function BedOccupancyStatsResponseGenderDistributionToJSON(json: any): BedOccupancyStatsResponseGenderDistribution {
    return BedOccupancyStatsResponseGenderDistributionToJSONTyped(json, false);
}

export function BedOccupancyStatsResponseGenderDistributionToJSONTyped(value?: BedOccupancyStatsResponseGenderDistribution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'male_count': value['male_count'],
        'female_count': value['female_count'],
        'other_count': value['other_count'],
    };
}

